import { useEffect } from 'react'

// Entitlements raises it and Launch's panels hear it; they load in chunks of their own, so they meet on a window event.
const courseGrantChangedEvent = 'access:course-grant-changed'

/** Tells the course's page that the viewer's own grant on the course changed, such as by enrolling in it. */
export function announceCourseGrantChanged(courseId: string): void {
  window.dispatchEvent(new CustomEvent<string>(courseGrantChangedEvent, { detail: courseId }))
}

/** Calls `onChange` whenever the viewer's own grant on the course is changed from this page. */
export function useCourseGrantChanged(courseId: string, onChange: () => void): void {
  useEffect(() => {
    const listener = (event: Event) => {
      if (event instanceof CustomEvent && event.detail === courseId) {
        onChange()
      }
    }
    window.addEventListener(courseGrantChangedEvent, listener)
    return () => window.removeEventListener(courseGrantChangedEvent, listener)
  }, [courseId, onChange])
}
